import './stylesheets/default/TitleCard.css'
import './stylesheets/flat/TitleCardFlat.css'
import './stylesheets/neumorphism/TitleCardNeumorphism.css'
import './stylesheets/neobrutalism/TitleCardNeobrutalism.css'
import './stylesheets/glassmorphism/TitleCardGlassmorphism.css'

function TitleCard({style}){
    function capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    
const styleStrings = {
  "flat": {
    "tagline": "Clean. Simple. Bold.",
  },
  "neumorphism": {
    "tagline": "Soft UI, subtle depth.",
  },
  "neobrutalism": {
    "tagline": "Raw. Bold. Unapologetic.",
  },
  "glassmorphism": {
    "tagline": "Frosted elegance.",
  }
};


    return(
        <div className={`title-card-${style}`}>
            <h1 className={`${style}`}>{capitalizeFirstLetter(style)}</h1>
            <h2 className={`${style}`}>{styleStrings[style]["tagline"]}</h2>
        </div>
    )
}

export default TitleCard